import React, { Component } from "react";
import apiClient from '../lib/apiClient';
import Notification from "../components/Notification";
class Vote extends Component{
  constructor(props) {
    super(props);
    this.state = {
      lang: this.props.match.path.split("/")[1],
      availableSongs: [],
      chosenSongs: [],
      username: "",
      notificationVisibility: false,
      isLoading: true,
      disableButton: false
    }
  }

	async componentDidMount() {
    const availableSongs = await apiClient.getAllSongs();
		return this.setState({availableSongs, notificationVisibility: true, isLoading: false})
	}

  handleFormSubmit = async (event) => {
    const { availableSongs, chosenSongs, username, lang } = this.state;
    event.preventDefault();
    await availableSongs.forEach(song => {
      if (song.chosen) {
        chosenSongs.push(song._id);
      }
    });
    await apiClient.vote({ username, songs: chosenSongs });
    location.href = `https://max-and-sax.netlify.app/${lang}/ranking`;
  }

  handleChange = (event) => {
    const { availableSongs } = this.state;
    const newSongsArr = [...availableSongs];
    const id = event.target.value;
    const index = newSongsArr.findIndex(song => song._id === id);
    newSongsArr[index].chosen = event.target.checked;
    return this.setState({ availableSongs: newSongsArr });
  }

  handleName = (event) => {
    this.setState({username: event.target.value})
  }

  hideNotification = async () => {
    await this.setState({ notificationVisibility: false });
  }

  render() {
    const { availableSongs, lang, username, isLoading, notificationVisibility, disableButton } = this.state;
    const choose = {
      cat: "Tria tantes cançons com vulguis!",
      cas: "¡Elige tantas canciones como quieras!",
      en: "Choose as many songs as you want!",
      fr: "Choisissez autant de chansons que vous le souhaitez!",
      de: "Wählen Sie so viele Lieder aus, wie Sie möchten!"
    }
    const name = {
      cat: "Nom:",
      cas: "Nombre",
      en: "Name:",
      fr: "Nom:",
      de: "Name:"
    }
    const vote = {
      cat: "Vota",
      cas: "Vota",
      en: "Vote",
      fr: "Voter",
      de: "Abstimmung"
    }
    const compare = (a, b) => {
      if ( a.votes.length > b.votes.length ){
          return -1;
        }
        if ( a.votes.length < b.votes.length ){
          return 1;
        }
        return 0;
    }
  
    if (isLoading) {
      return <p className="main h-2/3">Loading...</p>
    }
    
    if (notificationVisibility) {
      return <div className="main h-full">
          <div className="pt-10">
            <Notification dynamic display={notificationVisibility} hideNotification={this.hideNotification} lang={lang}  />
          </div>
        </div>
    }
    
    return (
      <div className="main h-auto pb-5">
        <div className="flex flex-col items-center justify-around w-80 ml-5">
          <p className="text-3xl pt-5 pb-5">{choose[lang]}</p>
          <form onSubmit={this.handleFormSubmit}>
            <div className="flex justify-between items-baseline">
              <label className="text-xl">{name[lang]}  </label>
              <input required onChange={this.handleName} value={username} placeholder="Type something..." className="mb-5 p-1 rounded-sm"/>
            </div>

            {availableSongs.sort(compare).map((song, index) => {
              const { artist, played, name, _id, chosen, votes } = song;
              if (!played) {
                return <div key={index}>
                  <input type="checkbox" checked={chosen} value={_id} onChange={this.handleChange} /> {`${artist} - ${name} (${votes.length} votes)`}
                </div>
              } else {
                return "";
              }
              })
              }
            {!disableButton ?
              <div className="flex justify-center mt-5">
              <input type="submit" className="button mb-5" value={vote[lang]} /> 
              </div>
              : ""}
          </form>
        </div>
      </div>
    )
  }
}

export default Vote;